import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';

@Component({
  selector: 'app-open-review',
  templateUrl: './open-review.page.html',
  styleUrls: ['./open-review.page.scss'],
})
export class OpenReviewPage implements OnInit {
  @Input('review') review;
  Randomcolor: string;
  constructor(public modalCtrl: ModalController) {
    this.getColors();
  }

  ngOnInit() {}
  ionViewWillEnter() {
    console.log(this.review);
  }
  close() {
    this.modalCtrl.dismiss();
  }
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    this.Randomcolor = color;
  }

  async openImage(image) {
    let modal = await this.modalCtrl.create({
      component: PhotoViewerPage,
      componentProps: { image: image },
    });
    modal.present();
  }
}
